/** ID GA4 de producción (Google Analytics → ID de medición). */
export const GA_MEASUREMENT_ID = 'G-298803JCJ9';

const MEASUREMENT_ID = (process.env.REACT_APP_GA_MEASUREMENT_ID || GA_MEASUREMENT_ID).trim();

let initPromise = null;

export function isGoogleAnalyticsEnabled() {
  return Boolean(MEASUREMENT_ID);
}

function gtagAlreadyLoaded() {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

/**
 * Usa gtag cargado desde public/index.html; si no existe, lo inyecta (fallback).
 */
export function initGoogleAnalytics() {
  if (!MEASUREMENT_ID || typeof window === 'undefined') {
    return Promise.resolve(false);
  }
  if (gtagAlreadyLoaded()) {
    return Promise.resolve(true);
  }
  if (initPromise) return initPromise;

  initPromise = new Promise((resolve) => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
    script.onload = () => {
      window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
      resolve(true);
    };
    script.onerror = () => {
      initPromise = null;
      resolve(false);
    };
    document.head.appendChild(script);
  });

  return initPromise;
}

/**
 * Vista de página (navegación SPA). La carga inicial la envía index.html.
 */
export async function trackPageView(pagePath, pageTitle) {
  if (!MEASUREMENT_ID || typeof window === 'undefined') return;
  const ready = await initGoogleAnalytics();
  if (!ready || !gtagAlreadyLoaded()) return;

  window.gtag('config', MEASUREMENT_ID, {
    page_path: pagePath,
    page_title: pageTitle || document.title,
  });
}

export async function trackEvent(eventName, params = {}) {
  if (!MEASUREMENT_ID || typeof window === 'undefined') return;
  const ready = await initGoogleAnalytics();
  if (!ready || !gtagAlreadyLoaded()) return;
  window.gtag('event', eventName, params);
}
